import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CustomSnackBarComponent } from './custom-snack-bar.component';
import { IconComponent } from '../icon/icon.component';

@NgModule({
    declarations: [CustomSnackBarComponent],
    exports: [CustomSnackBarComponent],
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatSnackBarModule,
        IconComponent,
    ],
})
export class CustomSnackBarModule {}
